<div
  class="layout-sidebar-right"
  [ngClass]="{ 'layout-sidebar-right-active': switchDirectoryMenuActive }"
>
  <h5>Switch Directory</h5>
  <hr />
  <ng-container *ngIf="directories as directories">
    <button
      pButton
      type="button"
      class="p-button-raised"
      *ngFor="let directory of directories"
      [label]="directory.name"
      (click)="changeDirectory.emit(directory.id)"
      class="mb-3"
    ></button>
  </ng-container>
</div>
